import { createI18n } from "vue-i18n";
import messages, { availableLocales, defaultLocale, AppLocale } from "@/locales";

const storageKey = "locale";

function readStoredLocale(): AppLocale {
    try {
        const stored = localStorage.getItem(storageKey);
        if (stored && (availableLocales as readonly string[]).includes(stored)) {
            return stored as AppLocale;
        }
    } catch (error) {
        // localStorage bywa niedostępny (np. tryb prywatny) - zostaje język domyślny
    }
    return defaultLocale;
}

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: readStoredLocale(),
    fallbackLocale: defaultLocale,
    messages,
});

document.documentElement.lang = i18n.global.locale.value;

export function setLocale(locale: AppLocale): void {
    i18n.global.locale.value = locale;
    document.documentElement.lang = locale;
    try {
        localStorage.setItem(storageKey, locale);
    } catch (error) {
        // Bez zapisu wybór działa do odświeżenia strony
    }
}

export function t(key: string, values?: Record<string, unknown>): string {
    return values ? i18n.global.t(key, values) : i18n.global.t(key);
}

export default i18n;
